import React from 'react';
import $ from 'zzc-zepto';
import { connect } from 'react-redux';
import propTypes from 'prop-types';
import Clipboard from 'clipboard';
import {
  AbsoluteLayout,
  AbsoluteLayoutHeader,
  AbsoluteLayoutBody
} from '../FixedLayout';
import latLngDecimalToStandard from './latLngDecimalToStandard';
import renderNavbarRightPopover from '../../native/renderNavbarRightPopover';
//import share from '../../native/share';
import nativeEvent from '../../native/event';
import { push } from '../../native/navigator';
import Header from '../Header';
import TabType from './TabType';
import Introduction from './Introduction';
import Comment from './Comment';
import NextStation from './NextStation';
import DownloadBar from './DownloadBar';
import Detector from '../../utils/detector';
import toast from '../Toast';
import {throttle } from '../../utils/throttle';
import { getPoiComments } from '../../store/actions/poi';
import { ClipboardMenu } from './ClipboardMenu';
import localStorageItem from '../../utils/localStorageItem';
import preLoadImg from '../../utils/preLoadImg';
import { parseQuery} from '../../utils/url';
import { getType } from '../../helpers/poi';
import { forceCheck } from 'react-lazyload';
import { sendStatsEvent } from '../statistics';

const query = parseQuery();
const LSI = localStorageItem('POI_DETAIL');
const emptyTips = {
  'attraction' : '暂无合适的景点推荐',
  'food': '暂无合适的美食推荐'
};

class Poi extends React.Component {
  static propTypes = {
    poi: propTypes.object.isRequired,
    city: propTypes.object.isRequired,
    // onAdd与onRemove均可选，但最多只能传递一个
    onAdd: propTypes.func,
    onRemove: propTypes.func
  };

  constructor(props){
    super(props);
    this.state = {
      tabType: query.tab || 'introduction', //oneof['introduction','comments','nextStation']
      commentType: 'all',
      nextStation: {},
      nextStationType: 'attraction',
      hidebar: query.hidebar //探途地图查看poi详情页不需要显示头部
    };
    this.poiType = getType(props.poi.poi_uid);
    // this.showComment = this.poiType === 'attraction' || this.poiType === 'food' ? true : false;
    this.showComment = true;
  }
  render() {

    let { comments, status } = this.props;
    let { poi, city, nextStation, videos, onAdd, onRemove } = this.props;
    let _comments = {
      list: this.IntroductionComments ? this.IntroductionComments.list : this.getStaticData(3,comments.list),
      count: this.IntroductionComments ? this.IntroductionComments.count : comments.count
    };
    let { tabType, nextStationType, commentType} = this.state;

    return (
      <AbsoluteLayout id="poi2"
        className={this.state.hidebar ? 'hidebar' : ''}
        onClick={this.handleClickBody}
        onTouchMove={this.handleClickBody}>
        <AbsoluteLayoutHeader>
          <Header
            rightBtnType="dot"
            handleRightBtnClick={this.showNativeItem}>
            <TabType 
              showComment={this.showComment}
              tabType={tabType}
              changeTab={this.changeTab} />
          </Header>
        </AbsoluteLayoutHeader>

        <AbsoluteLayoutBody 
          className="main"
          onScroll={this.handleScroll}>
          <section className="introduction-wrap tab-content">
            <Introduction
              addActionBtnText={this.props.addActionBtnText}
              poiType={this.poiType}
              tabType={tabType}
              poi={poi}
              city={city}
              videos={videos}
              onAdd={onAdd}
              onRemove={onRemove}
              showComment={this.showComment}
              commentType={'all'}
              comments={_comments}
              handleChangeCommentType={this.changeCommentType}
              nextAttraction={this.getStaticData(5, nextStation.attraction)} 
              nextFood={this.getStaticData(5, nextStation.food)} 
              needShowMoreAttraction={nextStation.attraction && nextStation.attraction.length > 5? true: false}
              needShowMoreFood={nextStation.food && nextStation.food.length > 5? true: false}
              handleClickAddress={this.handleClickAddress} 
              showMore={this.showMoreContent}
              handleClickAskCard={this.handleClickAskCard}
              handleClickNextStation={this.handleClickNextStation}/>
          </section>
          {
            this.showComment ?
              <section className="comments-wrap  tab-content">
                <Comment 
                  className="no-border"
                  showCountTitle={false}
                  moreStatus={status}
                  commentType={commentType}
                  comments={comments}
                  handleChangeCommentType={this.changeCommentType}/>
              </section>
              : null
          }
         
          <section className="nextStation-wrap  tab-content">
            <NextStation
              poiInfo={poi}
              nextStationType={nextStationType} 
              stationList={nextStation[nextStationType]}
              emptyTips={emptyTips[nextStationType]}
              changeNextStationType={this.changeNextStationType}
              handleClickNextStation={this.handleClickNextStation} />
          </section>
        </AbsoluteLayoutBody>

        {Detector.browser.name === 'tantutravel' || Detector.browser.name === 'zuzuche' ? null : (<DownloadBar />)}
      </AbsoluteLayout>
       
    );
  }

  componentWillUpdate(nextProps, nextState){
    if(nextState.tabType !== this.state.tabType){
      this.updateTabContent(nextState.tabType);
      forceCheck();
    }
  }

  componentDidMount() {
    sendStatsEvent(`poi_${this.poiType}point_pv`);
    this.clipboardMenu = ClipboardMenu;
    this.initClipboardClickEvent();

    let { poi, getPoiComments } = this.props;
    let { commentType } = this.state;
    
    //存起全部类别下的前三个
    getPoiComments(poi.poi_uid,commentType,1)
      .then((res)=>{
        this.IntroductionComments = {
          count: {...res.count},
          list: this.getStaticData(3,[...res.list]) || []
        };
      });
   
    nativeEvent.on('navbar-right-popover-click', this.handleNavbarRightPopover);
    this.$tabContent = document.querySelectorAll('.tab-content');
    this.updateTabContent();
    
  }

  updateTabContent(tab){
    let _tab = tab || this.state.tabType;
    $('.tab-content').hide();
    $(`.${_tab}-wrap.tab-content`).show();
  }

  /**
   * 产品说这个版本不做 -  调出原生遮罩菜单栏 及点击事件
   */
  showNativeItem = ()=>{
    renderNavbarRightPopover([
      {title: '分享',id: 'share'},
      {title: '首页', id: 'index'}
    ]);
  }

  handleNavbarRightPopover = (index) => {
    switch (index) {
      case 0:
        //share(options);
        break;
      case 1:
        break;
      default:
        // TODO
    }
  };



  getStaticData(number, list){
    return (list && list.filter((item, index)=>{
      return index < number;
    })) || [];
  }

  /**
   * 点击问路卡
   */
  handleClickAskCard = ()=>{
    sendStatsEvent('poi_direction_click');
    let { poi } = this.props;
    LSI.setItem('detail', poi.info);
    preLoadImg(`${poi.info.pic.base}!/fw/750/gaussblur/30x5`);
    push('/m/v2/?m=render2&page=ask-road-card');
  }

  /**
   * 切换评论类型
   */
  changeCommentType = (type)=>{
    if(type === 'pic'){
      sendStatsEvent('poi_commenttype_click_1');
    }else if(type === 'good'){
      sendStatsEvent('poi_commenttype_click_2');
    }else if(type === 'general'){
      sendStatsEvent('poi_commenttype_click_3');
    }else if(type === 'bad'){
      sendStatsEvent('poi_commenttype_click_4');
    }
    sendStatsEvent('poi_commenttype_click');
    let { commentType } = this.state;
    if(commentType === type ) return;
    this.setState({
      tabType: 'comments',
      commentType: type
    });

    let { poi, getPoiComments} = this.props;

    
    getPoiComments(poi.poi_uid,type,1);
    document.querySelector('.main-body').scrollTop = 0;
  }

  /**
  * 处理滑动到底部加载更多事件
  */
  handleScroll = throttle((e)=>{
    forceCheck();
    let { tabType } = this.state;
    if(tabType !== 'comments' ) return;

    let screenH = document.querySelector('.main-body').clientHeight;
    let scrollTop = document.querySelector('.main-body').scrollTop;
    let scrollHeight = document.querySelector('.comments-wrap').clientHeight;

    if (scrollTop === 0) return;
    if (scrollHeight - scrollTop - screenH < 10) {
      let { poi, nextPage, getPoiComments} = this.props;
      let { commentType }= this.state;
      getPoiComments(poi.poi_uid,commentType,nextPage);
    }
  }, 500)


  /**
   * 查看更多评论／景点／美食都在这里
   */
  showMoreContent = (tab)=>{
    if(tab === 'comments'){
      sendStatsEvent('poi_allcomment_click_2');
      this.setState({
        tabType: 'comments',
        commentType: 'all'
      });
  
      let { poi, getPoiComments} = this.props;
      getPoiComments(poi.poi_uid, 'all' ,1);
    }else{
      if(tab === 'attraction'){
        sendStatsEvent('poi_allnextpoi_click_1');
      }else{
        sendStatsEvent('poi_allnextpoi_click_2');
      }
      this.setState({
        tabType: 'nextStation',
        nextStationType: tab
      });
    }
    document.querySelector('.main-body').scrollTop = 0;
  }

  /**
   * 切换顶部介绍评价下一站三个tab
   */
  changeTab = (tab)=>{
    if(tab === 'comments'){
      sendStatsEvent('poi_allcomment_click_1');
    }else if(tab === 'nextStation'){
      sendStatsEvent('poi_allnextpoi_click_1');
    }
    let { tabType } = this.state;
    if(tab === tabType) return;
    this.setState({tabType: tab});
    $('.tab-content').hide();
    document.querySelector('.main-body').scrollTop = 0;
    
  }

  /**
   * 切换下一站景点 ／ 美食tab 
   */
  changeNextStationType = (tab)=>{
    let { nextStationType } = this.state;
    if(tab === nextStationType) return;
    this.setState({nextStationType: tab});
    document.querySelector('.main-body').scrollTop = 0;
  }

  /**
   * 点击下一站 --  先这样保证跳转吧
   * 可能家泳要打死我
   */
  handleClickNextStation =(poi)=>{
    let page = query.page;
    //酒店跳去下一站的话直接去到poi
    let currentIsHotelPage = query.page.indexOf('hotel') > -1;
    if(currentIsHotelPage){
      page = 'poi';
    }

    let poiStyle = 'ZZCAppArg=topBar_Remove,webviewStart_StatusBar,NoWebviewSlide';
    if(Detector.browser.name === 'zuzuche'){
      poiStyle = 'hideTopBar=true&ZZCAppArg=topBar_Remove,webviewStart_StatusBar,NoWebviewSlide';
    }
    
    let url = `/m/v2/?m=render2&page=${page}&poi_uid=${poi.poi_uid}`;
    if(query.trip_id){
      url += `&trip_id=${query.trip_id}`;
    }
    if(query.day){
      url += `&day=${query.day}`;
    }
    url += `&${poiStyle}`;
    console.log(url);
    window.location = url;
  }

  /**
   * 粘贴板工具初始化
   */
  initClipboardClickEvent = ()=>{
    let _this = this;
    let clipboard = new Clipboard('.clipboard-trigger', {
      text: function (trigger) {
        let dataKey = trigger.getAttribute('data-key');
        let result = ' ';
        let info = _this.props.poi.info;
        if (dataKey === 'latlng') {
          result = latLngDecimalToStandard(info.lat, 'lat') + ', ' + latLngDecimalToStandard(info.lng, 'lng');
        } else {
          result = info['address'];
        }
        return result;
      }
    });
    clipboard.on('success', e => {
      toast('复制成功');
    });
    clipboard.on('error', err => {
      console.log(err);
    });
  }


  handleClickBody = () => {
    this.clipboardMenu.isShow && this.clipboardMenu.hide();
  }

  /**
   * 点击地址出现复制选择菜单
   */
  handleClickAddress = (e, info) => {
    sendStatsEvent('poi_address_click');
    e.stopPropagation();
    e.preventDefault();

    if (this.clipboardMenu.isShow) {
      this.clipboardMenu.hide();
    } else {
      let t = e.currentTarget;
      let top = t.offsetTop - document.querySelector('.main-body').scrollTop + 44,
        width = t.clientWidth,
        left = t.offsetLeft + width / 2;

      let items = [];

      if (info.address) {
        items.push({
          name: '复制地址',
          key: 'address'
        });
      }

      if (info.lat && info.lng) {
        items.push({
          name: '复制经纬度',
          key: 'latlng'
        });
      }

      this.clipboardMenu.show({
        left, top, items
      });
    }
  }


  
}



const PoiConnect = connect(function (state, ownProps) {
  return {
    ...ownProps,
    comments:state.poi.poiComments.data,
    status:state.poi.poiComments.status,
    nextPage:state.poi.poiComments.data.next_page
  };
},{
  getPoiComments
})(Poi);
export default PoiConnect;


// WEBPACK FOOTER //
// ./src/components/Poi2/Poi.js